import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";
import { usePagination } from "@/utils/stores/pagination";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "leaseAgreement";

export const useLeaseAgreementStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "id");
  const { paginatedResources, goToPage, goToNextPage, goToPreviousPage, paginationRange, totalPages, currentPage } = usePagination(sortedResources, 10);
  const { baseFetchOne, baseDelete, baseMultipartSave } = useBase(storeName);

  const empty = {};

  const save = async (resource, rentalListingAgreementId, propertyId, callback, errorCallback) => {
    const path = `rental-listing-agreements/${rentalListingAgreementId}/properties/${propertyId}/lease-agreements`;
    return await baseMultipartSave(path, resource, callback, errorCallback);
  };

  const fetchOne = async (id, rentalListingAgreementId, propertyId, errorCallback) => {
    const path = `rental-listing-agreements/${rentalListingAgreementId}/properties/${propertyId}/lease-agreements`;
    return await baseFetchOne(path, id, errorCallback);
  };

  const destroy = async (id, rentalListingAgreementId, propertyId, errorCallback) => {
    const path = `rental-listing-agreements/${rentalListingAgreementId}/properties/${propertyId}/lease-agreements`;
    return await baseDelete(path, id, null, errorCallback);
  };

  return {
    all,
    currentPage,
    empty,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: paginatedResources,
    paginationRange,
    save,
    destroy,
    searchQuery,
    sorted: sortedResources,
    totalPages,
  };
});
